import { useReduxState } from 'hooks';
import { localeLanguageCodes, localeNames, Locales } from 'shared-locales';
import { FlagIcon, Tooltip } from 'components/common';
import { CSSProperties } from 'react';

interface Props {
  iconStyle?: CSSProperties;
  isButton?: boolean;
  isButtonActive?: boolean;
  language: Locales;
  onClick?: () => void;
  size?: 'small' | 'medium' | 'large';
}

const LanguageIcon = ({
  iconStyle,
  isButton = false,
  isButtonActive = false,
  language,
  onClick,
  size
}: Props) => {
  const { theme } = useReduxState();

  const WrapperEl = isButton ? 'button' : 'div';

  return (
    <Tooltip childrenWrapInDiv={false} content={localeNames[language]}>
      <WrapperEl
        className={`language ${isButton ? 'language-button' : ''} ${
          isButtonActive ? 'language-button-active' : ''
        }`}
        onClick={onClick}
      >
        <FlagIcon
          lang={localeLanguageCodes[language]}
          size={size}
          style={iconStyle}
        />

        <style jsx>{`
          .language {
            align-items: center;
            display: inline-flex;
            gap: 5px;
          }
          .language-button {
            background-color: transparent;
            border: 0;
            border-radius: ${theme.inputBorderRadius};
            color: inherit;
            cursor: pointer;
            font-family: inherit;
            font-size: 1.5rem;
            outline: 0;
            padding: 4px 4px;
            transition: background-color 0.2s;
          }
          .language-button:hover {
            background-color: ${theme.lightGrey};
          }
          .language-button:focus,
          .language-button-active {
            background-color: ${theme.lightGreyDark};
          }
        `}</style>
      </WrapperEl>
    </Tooltip>
  );
};

export default LanguageIcon;
